// Default Imports
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

// Tailwind + shadcn styles (PRIMARY - load first)
import "./styles/globals.css";

// Third-party component styles (minimal, specific)
import "react-phone-input-2/lib/style.css";

// Redux Imports
import { Store } from "./state";

// Components Imports
import NavigationRoutes from "./routes";

import { Toaster } from "sonner";
import { BasicContextProvider } from "./contextApi/BasicContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BasicContextProvider>
    <BrowserRouter>
      <Provider store={Store}>
        <NavigationRoutes />
        <Toaster position="bottom-right" richColors closeButton />
      </Provider>
    </BrowserRouter>
  </BasicContextProvider>
);
